import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
//
import { useAuthContext } from 'src/auth/hooks';
import MaintenanceBanner from 'src/components/maintenance-banner/maintenance-banner';
import RedirectWithTimer from 'src/components/redirect-with-timer';
import useBrandName from 'src/hooks/use-brand-name';
import Header from './header';
import Main from './main';
import NavHorizontal from './nav-horizontal';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const { user } = useAuthContext();
  const { isAgent, isTryVisa, isAgentPurpose } = useBrandName();
  console.log('user123433', user);
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const nav = useBoolean();

  const isHorizontal = settings.themeLayout === 'horizontal';

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini />;

  const renderHorizontal = <NavHorizontal />;

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />;

  if (isTryVisa && isAgentPurpose && user?.purpose) {
    return <RedirectWithTimer redirectType="agent" />;
  }

  if (isAgent && !isAgentPurpose && user?.purpose) {
    return <RedirectWithTimer redirectType="tryvisa" />;
  }

  if (isHorizontal) {
    return (
      <>
        <MaintenanceBanner />
        <Header onOpenNav={nav.onTrue} />

        {/* {lgUp ? renderHorizontal : renderNavVertical} */}

        <Main>{children}</Main>
      </>
    );
  }

  if (isMini) {
    return (
      <>
        <MaintenanceBanner />
        <Header onOpenNav={nav.onTrue} />

        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          {/* {lgUp ? renderNavMini : renderNavVertical} */}

          <Main>{children}</Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <MaintenanceBanner />
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        {/* {renderNavVertical} */}

        <Main>{children}</Main>
      </Box>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
